export const clamp = (x, lo, hi) => Math.max(lo, Math.min(hi, x));

export function alignDateToInterval(dateString, interval) {
  const d = new Date(dateString);
  if (interval === "weekly") { const day = d.getDay(); d.setDate(d.getDate() - day + (day === 0 ? -6 : 1)); }
  else if (interval === "monthly") d.setDate(1);
  return d.toISOString().split("T")[0];
}

export function aggregateToInterval(data, interval) {
  if (interval === "daily") {
    return (data || []).map(({ date, close }) => {
      const [Y, M, D] = date.split("-").map(Number);
      return { time: Date.UTC(Y, M - 1, D) / 1000, value: close };
    }).sort((a,b)=>a.time-b.time);
  }
  const grouped = {};
  (data || []).forEach(({ date, close }) => {
    const key = alignDateToInterval(date, interval);
    (grouped[key] = grouped[key] || []).push(close);
  });
  return Object.entries(grouped).map(([s, prices]) => {
    const [Y, M, D] = s.split("-").map(Number);
    return { time: Date.UTC(Y, M - 1, D)/1000, value: prices.reduce((a,v)=>a+v,0)/prices.length };
  }).sort((a,b)=>a.time-b.time);
}

export function nearestPoint(series, t, maxGapSec = 60*60*24*45) {
  if (!series?.length) return null;
  let lo=0, hi=series.length-1;
  if (t <= series[0].time)   return (series[0].time - t   <= maxGapSec) ? series[0] : null;
  if (t >= series[hi].time)  return (t - series[hi].time  <= maxGapSec) ? series[hi] : null;
  while (lo <= hi) { const m=(lo+hi)>>1, tm=series[m].time; if (tm===t) return series[m]; (tm<t)?(lo=m+1):(hi=m-1); }
  const before = series[hi], after = series[lo];
  return (t - before.time) <= (after.time - t) ? before : after;
}
